import Vue from 'vue'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ContentAlarmsGrid } from '@/modules/configurationModule/detail/notifications/components/alarms-grid/alarms-grid.models'

class AlarmNotificationConfigurationServices extends Vue {
    async paginator(filterModel: any, params: any, laboratoryId: number): Promise<IResponseAgGrid<ContentAlarmsGrid>> {
        const response = await this.axios.put(`/configuration/laboratories/${laboratoryId}/alarmConfiguration`, filterModel, { params })
        return response.data
    }
    async getAlarmNotificationById(notificationConfigurationId: number, laboratoryId: number): Promise<ContentAlarmsGrid> {
        const response = await this.axios.get(`/configuration/laboratories/${laboratoryId}/alarmConfiguration/${notificationConfigurationId}`)
        return response.data
    }
    async patchAlarmNotificationBatch(request: ContentAlarmsGrid[], laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.patch(`/configuration/laboratories/${laboratoryId}/alarmConfiguration/batch`, request)
        return response.data
    }
    async createAlarmNotification(request: ContentAlarmsGrid, laboratoryId: number): Promise<ContentAlarmsGrid> {
        const response = await this.axios.post(`/configuration/laboratories/${laboratoryId}/alarmConfiguration`, request)
        return response.data
    }
    async deleteAlarmNotificationBatch(request: EntityIdentifiersRequest, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await this.axios.delete(`/configuration/laboratories/${laboratoryId}/alarmConfiguration/batch`, { data: request })
        return response.data
    }
}

export const alarmNotificationConfigurationServices = new AlarmNotificationConfigurationServices()
